import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {Shared} from "../../../shared/shared";
import {Data} from "@angular/router";
import {Observable, of} from "rxjs";
import {fromArray} from "rxjs/internal/observable/fromArray";


@Component({
  selector: 'app-table',
  templateUrl: 'table.html',
  styleUrls: ['table.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Table implements OnChanges {

  @Input() columns: any;
  @Input() rows: any;
  @Input() currentPage: any = 1;
  /**
   * Casillas de seleccion a la izquierda, con la de seleccionar todo en la cabecera.
   *
   * OJO: en este modo, pinchar la FILA ya no abre nada. Es de ng2-smart-table y no se puede
   * cambiar desde fuera: con selectMode 'multi' el clic en la fila se lo queda la seleccion y
   * userRowSelect solo lo dispara la casilla. Quien encienda esto tiene que dar otra forma de
   * abrir el elemento (un boton en su propia columna).
   */
  @Input() multiSelect = false;

  ngOnChanges(changes: SimpleChanges) {
    this.checkLength();
    // ng2-smart-table lee selectMode al construirse, asi que encender o apagar las casillas
    // obliga a rehacer la tabla. Sin esto, cambiar de pestana dejaba las casillas de la anterior.
    if (changes['multiSelect'] && !changes['multiSelect'].firstChange) {
      this.selectionChanged.emit([]);
      this.changeNumOfElements();
    }
  }

  showTable = true;
  numOfElements = 10;
  optionsElements = [10,20,50,100,500];

  @Output() rowSelectedEmitter = new EventEmitter<string>();
  /** Las filas marcadas ahora mismo. Se emite en cada cambio, incluida la casilla de la cabecera. */
  @Output() selectionChanged = new EventEmitter<any[]>();

  totalRows;

  constructor() {
  }

  ngOnInit() {
    this.changeNumOfElements();
    this.checkLength();

    const obsPage = of(this.currentPage);
    obsPage.subscribe(x=>{
      console.log("PageChange-"+x);
    });
  }

  async changeNumOfElements(){
    if(this.columns!=null) {
      this.showTable = false;
      this.columns.selectMode = this.multiSelect ? 'multi' : 'single';
      this.columns.pager = {};
      this.columns.pager.display = true;
      this.columns.pager.perPage = this.numOfElements;
      await this.delay(200);
      this.showTable = true;
    }
  }

  changePage(currentPage){
    this.rows.setPage(currentPage);
  }

  checkLength(){
    if(this.rows!=null) {
      this.totalRows = this.rows.length;
    }else{
      this.totalRows = 0;
    }
  }

  onUserRowSelect(event) {
    if (this.multiSelect) {
      // En seleccion multiple esto lo dispara la casilla (o la de seleccionar todo, y entonces
      // event.data viene a null). Lo que interesa es la lista entera, no la fila tocada.
      this.selectionChanged.emit(event.selected == null ? [] : event.selected);
      return;
    }
    this.rowSelectedEmitter.emit(event.data);
  }

  async waitForIt(){
    while(this.rows == null || this.rows == undefined){
      await this.delay(200);
    }
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
